export const COLUMNS = [
    {
      Header: 'Id',
      Footer: 'Id',
      accessor: 'id',
      disableFilters: true,
      sticky: 'left'
    },
    {
      Header: 'Title',
      Footer: 'Title',
      accessor: 'testimonialTitle',
      sticky: 'left'
    },
    {
      Header: 'Description',
      Footer: 'Description',
      accessor: 'testimonialDesc',
      sticky: 'left'
    },
    {
      Header: 'Author Name',
      Footer: 'Author Name',
      accessor: 'authorName',
      sticky: 'left'
    },
    {
      Header: 'Author Image',
      Footer: 'Author Image',
      accessor: 'authorImg',
      sticky: 'left'
    }
  ]